import { render } from "./Featured_Prompts.vue?vue&type=template&id=0dfad6fe"
import script from "./Featured_Prompts.vue?vue&type=script&lang=js"
export * from "./Featured_Prompts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/voltz/Documents/Github/Website/CraftMasters/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__